import {useEffect, useRef} from 'react'
import {useLocation} from 'react-router-dom'
import {trackNav, startHeartbeat, stopHeartbeat} from './analyticsService'

// Standalone activity tracker — completely separate from Google Analytics.
// Mount once inside the authenticated route tree (PrivateRoute.js).
// Handles: session heartbeat (on login) + navigation events (on route change).
export default function ActivityTracker() {
  const {pathname} = useLocation()
  const prevRef = useRef(null)
  const enteredAtRef = useRef(Date.now())

  useEffect(() => {
    startHeartbeat()
    return () => stopHeartbeat()
  }, [])

  
useEffect(() => {
    if (prevRef.current !== null && prevRef.current !== pathname) {
      const elapsed = Math.round((Date.now() - enteredAtRef.current) / 1000)
      trackNav(prevRef.current, elapsed)
    }
    prevRef.current = pathname
    enteredAtRef.current = Date.now()
  }, [pathname])

  return null
}
